/* ==========================================================================
   TITANOX — comportements globaux
   Aucun framework, aucune dependance. Initialisation idempotente.

   CORRECTIFS :
   - proche() remplace e.target.closest() partout (garde-fou anti-exception).
   - initReco() : recuperation des recommandations produit via la Section
     Rendering API, sinon la section restait vide en permanence.
   - window.TX securise avant ecriture.
   ========================================================================== */
(function () {
  'use strict';

  var TX = window.TX || {};
  var routes = TX.routes || {};

  /* ------------------------------------------------------------- outils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // e.target peut etre document, un noeud SVG ancien ou un noeud texte :
  // .closest n'existe pas partout. Sans ce garde-fou, une exception ici
  // stoppait le gestionnaire de clic global.
  function proche(cible, sel) {
    if (!cible || typeof cible.closest !== 'function') return null;
    return cible.closest(sel);
  }

  function annonce(msg) {
    var zone = $('#tx-annonce-live');
    if (!zone) {
      zone = document.createElement('div');
      zone.id = 'tx-annonce-live';
      zone.setAttribute('aria-live', 'polite');
      zone.className = 'tx-invisible';
      document.body.appendChild(zone);
    }
    zone.textContent = msg;
  }

  /* ------------------------------------------------------------ tiroirs */
  // Les tiroirs sont deplaces dans <body> pour sortir du contexte
  // d'empilement cree par l'entete sticky.
  function deplacerTiroirs() {
    $$('.tx-tiroir').forEach(function (t) {
      if (t.parentElement !== document.body) document.body.appendChild(t);
    });
  }

  function ouvrirTiroir(id) {
    var t = document.getElementById(id);
    if (!t) return;
    t.classList.add('est-ouvert');
    document.body.style.overflow = 'hidden';
    var focusable = t.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }

  function fermerTiroir(t) {
    if (!t) return;
    t.classList.remove('est-ouvert');
    if (!$('.tx-tiroir.est-ouvert')) document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var ouvre = proche(e.target, '[data-tx-ouvre]');
    if (ouvre) {
      e.preventDefault();
      ouvrirTiroir(ouvre.getAttribute('data-tx-ouvre'));
      return;
    }
    var ferme = proche(e.target, '[data-tx-ferme]');
    if (ferme) {
      e.preventDefault();
      fermerTiroir(ferme.closest('.tx-tiroir'));
      return;
    }
    if (e.target.classList && e.target.classList.contains('tx-tiroir__voile')) {
      fermerTiroir(proche(e.target, '.tx-tiroir'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var ouvert = $('.tx-tiroir.est-ouvert');
    if (ouvert) fermerTiroir(ouvert);
    var popup = $('.tx-popup.est-ouvert');
    if (popup) popup.classList.remove('est-ouvert');
  });

  /* -------------------------------------------------------------- panier */
  function rafraichirPanier() {
    var url = routes.racine || '/';
    if (url.slice(-1) !== '/') url += '/';
    return fetch(url + '?section_id=tx-panier-tiroir', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neuf = doc.querySelector('#tx-panier-contenu');
        var actuel = $('#tx-panier-contenu');
        if (neuf && actuel) actuel.innerHTML = neuf.innerHTML;
        return fetch((routes.panier || '/cart') + '.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        $$('[data-tx-compte]').forEach(function (n) {
          n.textContent = panier.item_count;
          n.hidden = panier.item_count === 0;
        });
        return panier;
      })
      .catch(function () { /* silencieux : le panier reste utilisable en page /cart */ });
  }

  // Ajout au panier sans rechargement
  document.addEventListener('submit', function (e) {
    var form = proche(e.target, 'form[data-tx-ajout]');
    if (!form) return;
    e.preventDefault();

    var bouton = form.querySelector('button[type="submit"]');
    var libelle = bouton ? bouton.innerHTML : '';
    if (bouton) { bouton.disabled = true; bouton.innerHTML = 'Ajout...'; }

    fetch(routes.panier_ajout || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        return rafraichirPanier();
      })
      .then(function () {
        annonce('Produit ajoute au panier');
        if (TX.panierTiroir) ouvrirTiroir('tx-panier');
      })
      .catch(function (err) {
        annonce('Ajout impossible');
        if (window.console) console.warn('[TX] ajout panier', err);
      })
      .then(function () {
        if (bouton) { bouton.disabled = false; bouton.innerHTML = libelle; }
      });
  });

  // Modification des quantites
  document.addEventListener('click', function (e) {
    var btn = proche(e.target, '[data-tx-qte]');
    if (!btn) return;
    e.preventDefault();
    var champ = btn.parentElement.querySelector('input');
    if (!champ) return;
    var valeur = parseInt(champ.value, 10) || 0;
    valeur += btn.getAttribute('data-tx-qte') === 'plus' ? 1 : -1;
    if (valeur < 0) valeur = 0;
    majLigne(champ.getAttribute('data-cle'), valeur);
  });

  document.addEventListener('change', function (e) {
    var champ = proche(e.target, 'input[data-cle]');
    if (!champ) return;
    majLigne(champ.getAttribute('data-cle'), parseInt(champ.value, 10) || 0);
  });

  document.addEventListener('click', function (e) {
    var sup = proche(e.target, '[data-tx-supprime]');
    if (!sup) return;
    e.preventDefault();
    majLigne(sup.getAttribute('data-tx-supprime'), 0);
  });

  function majLigne(cle, quantite) {
    if (!cle) return;
    fetch(routes.panier_maj || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: cle, quantity: quantite }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('tx-modele-cart')) {
          window.location.reload();
        } else {
          rafraichirPanier();
        }
      })
      .catch(function () { annonce('Mise a jour impossible'); });
  }

  /* ---------------------------------------------------------- accordeons */
  document.addEventListener('click', function (e) {
    var tete = proche(e.target, '.tx-accordeon__tete');
    if (!tete) return;
    var ouvert = tete.getAttribute('aria-expanded') === 'true';
    tete.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
    var corps = document.getElementById(tete.getAttribute('aria-controls'));
    if (corps) corps.hidden = ouvert;
  });

  /* ---------------------------------------------------------- carrousels */
  function initRail(rail) {
    if (rail.dataset.txPret === '1') return;
    rail.dataset.txPret = '1';

    var points = rail.parentElement.querySelector('.tx-points');
    var prec = rail.parentElement.querySelector('[data-tx-prec]');
    var suiv = rail.parentElement.querySelector('[data-tx-suiv]');
    var items = Array.prototype.slice.call(rail.children);
    if (!items.length) return;

    function pas() {
      var a = items[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
      return a + gap;
    }

    if (prec) prec.addEventListener('click', function () { rail.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    if (suiv) suiv.addEventListener('click', function () { rail.scrollBy({ left: pas(), behavior: 'smooth' }); });

    if (points) {
      points.innerHTML = '';
      items.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Element ' + (i + 1));
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        b.addEventListener('click', function () {
          rail.scrollTo({ left: item.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        });
        points.appendChild(b);
      });

      var minuteur;
      rail.addEventListener('scroll', function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(function () {
          var centre = rail.scrollLeft + rail.clientWidth / 2;
          var actif = 0;
          var meilleur = Infinity;
          items.forEach(function (item, i) {
            var c = item.offsetLeft - rail.offsetLeft + item.offsetWidth / 2;
            var d = Math.abs(c - centre);
            if (d < meilleur) { meilleur = d; actif = i; }
          });
          Array.prototype.forEach.call(points.children, function (b, i) {
            b.setAttribute('aria-current', i === actif ? 'true' : 'false');
          });
        }, 80);
      }, { passive: true });
    }
  }

  /* ----------------------------------------------------- retour en haut */
  function initHaut() {
    var btn = $('.tx-haut');
    if (!btn || btn.dataset.txPret === '1') return;
    btn.dataset.txPret = '1';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    window.addEventListener('scroll', function () {
      btn.classList.toggle('est-visible', window.scrollY > 600);
    }, { passive: true });
  }

  /* ------------------------------------------------------------- popup */
  function initPopup() {
    var popup = $('.tx-popup');
    if (!popup || popup.dataset.txPret === '1') return;
    popup.dataset.txPret = '1';

    var cle = 'tx-popup-vu';
    var delai = parseInt(popup.getAttribute('data-delai'), 10) || 5;

    popup.addEventListener('click', function (e) {
      if (e.target === popup || proche(e.target, '.tx-popup__fermer')) {
        popup.classList.remove('est-ouvert');
        try { sessionStorage.setItem(cle, '1'); } catch (err) { /* mode prive */ }
      }
    });

    if (TX.modeEditeur) return;
    var deja = false;
    try { deja = sessionStorage.getItem(cle) === '1'; } catch (err) { deja = false; }
    if (deja) return;

    setTimeout(function () { popup.classList.add('est-ouvert'); }, delai * 1000);
  }

  /* --------------------------------------------------------------- tri */
  document.addEventListener('click', function (e) {
    var btn = proche(e.target, '[data-tx-tri]');
    if (!btn) return;
    e.preventDefault();
    var liste = document.getElementById(btn.getAttribute('aria-controls'));
    if (!liste) return;
    var ouvert = liste.classList.toggle('est-ouvert');
    btn.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
  });

  /* -------------------------------------------------------- galerie produit */
  function initGalerie(galerie) {
    if (galerie.dataset.txPret === '1') return;
    galerie.dataset.txPret = '1';

    var scene = galerie.querySelector('.tx-galerie__scene');
    var vues = $$('.tx-galerie__vue', galerie);
    var vignettes = $$('.tx-galerie__vignette', galerie);
    if (!scene || !vues.length) return;

    function aller(i) {
      if (!vues[i]) return;
      scene.scrollTo({ left: vues[i].offsetLeft - scene.offsetLeft, behavior: 'smooth' });
    }

    vignettes.forEach(function (v, i) {
      v.addEventListener('click', function () { aller(i); });
    });

    var prec = galerie.querySelector('.tx-galerie__fleche--prec');
    var suiv = galerie.querySelector('.tx-galerie__fleche--suiv');
    function indexActif() {
      var centre = scene.scrollLeft + scene.clientWidth / 2;
      var actif = 0;
      var meilleur = Infinity;
      vues.forEach(function (vue, i) {
        var c = vue.offsetLeft - scene.offsetLeft + vue.offsetWidth / 2;
        var d = Math.abs(c - centre);
        if (d < meilleur) { meilleur = d; actif = i; }
      });
      return actif;
    }
    if (prec) prec.addEventListener('click', function () { aller(Math.max(0, indexActif() - 1)); });
    if (suiv) suiv.addEventListener('click', function () { aller(Math.min(vues.length - 1, indexActif() + 1)); });

    var minuteur;
    scene.addEventListener('scroll', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        var actif = indexActif();
        vignettes.forEach(function (v, i) {
          v.setAttribute('aria-current', i === actif ? 'true' : 'false');
        });
      }, 80);
    }, { passive: true });
  }

  /* --------------------------------------------------- variantes produit */
  function initVariantes(bloc) {
    if (bloc.dataset.txPret === '1') return;
    bloc.dataset.txPret = '1';

    var donnees;
    try { donnees = JSON.parse(bloc.querySelector('[data-tx-variantes]').textContent); }
    catch (err) { return; }

    var champId = bloc.querySelector('input[name="id"]');
    var prixZone = bloc.querySelector('[data-tx-prix]');
    var boutonAjout = bloc.querySelector('[data-tx-bouton-ajout]');
    var puces = $$('.tx-options__puce', bloc);
    if (!champId || !puces.length) return;

    function choix() {
      var valeurs = [];
      $$('.tx-options', bloc).forEach(function (groupe) {
        var actif = groupe.querySelector('.tx-options__puce[aria-pressed="true"]');
        valeurs.push(actif ? actif.getAttribute('data-valeur') : null);
      });
      return valeurs;
    }

    function appliquer() {
      var valeurs = choix();
      var trouve = null;
      donnees.forEach(function (v) {
        var ok = true;
        valeurs.forEach(function (val, i) {
          if (val !== null && v.options[i] !== val) ok = false;
        });
        if (ok && !trouve) trouve = v;
      });
      if (!trouve) return;

      champId.value = trouve.id;

      if (prixZone) {
        var html = '<span class="tx-prix__actuel">' + trouve.prix + '</span>';
        if (trouve.barre) html += '<s class="tx-prix__barre">' + trouve.barre + '</s>';
        prixZone.innerHTML = html;
      }

      if (boutonAjout) {
        boutonAjout.disabled = !trouve.dispo;
        boutonAjout.innerHTML = trouve.dispo ? boutonAjout.getAttribute('data-libelle') : 'Epuise';
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', trouve.id);
      window.history.replaceState({}, '', url.toString());
    }

    puces.forEach(function (p) {
      p.addEventListener('click', function () {
        var groupe = proche(p, '.tx-options__lot');
        $$('.tx-options__puce', groupe).forEach(function (autre) {
          autre.setAttribute('aria-pressed', 'false');
        });
        p.setAttribute('aria-pressed', 'true');
        appliquer();
      });
    });

    appliquer();
  }

  /* ------------------------------------------------- recommandations produit */
  // recommendations.performed est faux au premier rendu : il faut aller
  // chercher la section une seconde fois via product_recommendations_url.
  function initReco(zone) {
    if (zone.dataset.txPret === '1') return;
    zone.dataset.txPret = '1';

    var url = zone.getAttribute('data-tx-url');
    if (!url) return;

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neuf = doc.querySelector('[data-tx-reco]');
        if (!neuf) return;
        var grille = neuf.querySelector('.tx-grille');
        if (!grille || grille.children.length === 0) return;
        zone.innerHTML = neuf.innerHTML;
      })
      .catch(function () { /* silencieux : le repli reste affiche */ });
  }

  /* ------------------------------------------------------------- demarrage */
  function init() {
    deplacerTiroirs();
    $$('.tx-rail').forEach(initRail);
    $$('.tx-galerie').forEach(initGalerie);
    $$('[data-tx-produit]').forEach(initVariantes);
    $$('[data-tx-reco]').forEach(initReco);
    initHaut();
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Editeur de theme : re-initialisation apres rendu d'une section
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);

  window.TX = window.TX || {};
  window.TX.rafraichirPanier = rafraichirPanier;
  window.TX.ouvrirTiroir = ouvrirTiroir;
})();
